
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[state]/[...serviceGenPage]",
      function () {
        return require("private-next-pages/[state]/[...serviceGenPage].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[state]/[...serviceGenPage]"])
      });
    }
  